import {h, Fragment} from "preact"
import { SerpElement, useCurrencyFormatting } from '@nosto/preact';
import {
  productImagePlaceholder,
  getUrlLastPath,
  getCustomFieldText,

} from '../helpers';
import { useState, useMemo, useEffect } from 'preact/hooks';
import { Review } from './elements';

export default function ProductNoGql({ product }) {
  const { format } = useCurrencyFormatting();

  const [productData, setProductData] = useState(null);

  const hasLabel = (array, label) => array?.includes(label);

 // const bestSellerLabel = '_label_Best Seller 🔥';
  //const twlAwardsWinnerLabel = '_label_🏆 TWL Awards Winner';
  const comingSoonTag = 'coming-soon';
  const hideQuickAddTag = 'hide-quick-add';
  const preOrderTag = 'pre-order';
  const OutOfStockTag = 'out-of-stock';
  const ignoreTag = 'nosto-ignore';

  console.log(product.customFields);

  const isOnSale = useMemo(
    () => product.listPrice && product.listPrice > product.price,
    [product.listPrice, product.price]
  );

  const isSoldOutItem = useMemo(() => !product.available, [product.available]);

  const hideQuickAdd = useMemo(() => {
    const result = hasLabel(product.tags1, hideQuickAddTag);
 
    return result ? 'hide' : '';
  }, [product.tags1]);

  const isPreOrder = useMemo(() => {
    const result = hasLabel(product.tags1, preOrderTag);
    if (result) {
      console.log('Preorder label has been added');
    }
    return result;
  }, [product.tags1]);

  const isComingSoon = useMemo(() => {
    const result = hasLabel(product.tags1, comingSoonTag);

    return result;
  }, [product.tags1]);

  const hasOutOfStockTag = useMemo(() => {
    const result = hasLabel(product.tags1, OutOfStockTag);

    return result;
  }, [product.tags1]);

  const ignoreProduct = useMemo(() => {
    const result = hasLabel(product.tags1, ignoreTag);
 
    return result ? 'hide' : '';
  }, [product.tags1]);
  

  /*const bestSeller = useMemo(() => {
    const result = hasLabel(product.tags1, bestSellerLabel);
    if (result) {
      console.log('Best Seller label has been added');
    }
    return result;
  }, [product.tags1]);

  const twlAwardsWinner = useMemo(() => {
    const result = hasLabel(product.tags1, twlAwardsWinnerLabel);
    if (result) {
      console.log('TWL Awards Winner label has been added');
    }
    return result;
  }, [product.tags1]);*/

  const labelTag = useMemo(() => {
    const label = product.tags1.find(tag => tag.startsWith('_label_'));
    
    return label ? label.replace('_label_', '') : null;
  }, [product.tags1]);

  const productHandle = useMemo(() => {
    return getUrlLastPath(product.url);
  }, [product.url]);

  const productQuery = useMemo(() => {
    let parts = product.name.split('-');
    if (parts.length >= 3) {
      parts.pop();
      return parts.join('-');
    }
  }, [product.name]);

   //console.log(productVariants, 'productVariants 💜');
  const currencySymbol = '$';
  const saveDiscount = product.listPrice - product.price;
  const hasSizeSkus = useMemo(() => {
    const sizeSkus = product.skus.filter((sku) =>
      sku.customFields.some((field) => field.key.toLowerCase() === 'size')
    );
    return sizeSkus.length > 0 ? sizeSkus.length : false;
  }, [product.skus]);

  const handleAddToCart = () => {
    if (hasSizeSkus > 1) return null;
    let prodId = product.productId;
    let skuId = product.skus[0].id;

    Nosto.addSkuToCart(
      { productId: prodId, skuId: skuId },
      '$!products[0].attributionKey'
    )
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:build'));
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('cart:open'));
      });
  };

  useEffect(() => {
    const fetchProductData = async () => {
        try {
            const response = await fetch(`${product.url}.js`);
            if (!response.ok) throw new Error("Failed to fetch product data");

            const data = await response.json();
            setProductData(data);
        } catch (error) {
            console.error(`Error fetching product ${product.url}:`, error);
        }
    };

    if (isSoldOutItem) {
        fetchProductData();
    }
  }, [product.url, isSoldOutItem]);

  return (
    <SerpElement
      as="article"
      hit={product}
      className={`gc_grid_item ${isSoldOutItem ? 'sold-out-item' : ''} ${ignoreProduct}`}
    >
      <div
        class="grid__item grid-product"
        data-product-handle={productHandle}
        data-product-id={product.productId}
        data-product-query={productQuery}
        data-current-product={productHandle}
        data-product-name={product.name}
        data-product-price={product.price}
        data-item-query="product-query"
      >
        <div class="grid-product__content has-quick-add">
          {labelTag && !isOnSale && !isPreOrder && (
            <div className="grid-product__tag grid-product__tag--custom">
              {labelTag}
            </div>
          )}

          {isPreOrder && (
            <div class="grid-product__tag grid-product__tag--custom">
              Pre-Order
            </div>
          )}
          
          {isOnSale && (
            <div class="grid-product__tag grid-product__tag--sale">Sale</div>
          )}

          <div class="grid__item-image-wrapper">
            <div class="grid-product__image-mask">
              <div class="grid-product__tag grid-product__tag--more-colours">
                More Colours
              </div>

              <div
                class="grid-product__quick-add-wrapper"
                style="display: block"
              >
                {/* 🟪 <!-- Quick Add 🟪 --> */}
                <div className={`grid-product__quick-add ${hideQuickAdd}`}>
                  <button
                    onClick={handleAddToCart}
                    type="button"
                    class="grid-product__quick-add-btn h5 text-heading add"
                    data-id={product.skus[0].id}
                    skuId={product.skus[0].id}
                    prodId={product.productId}
                    skusCheck={hasSizeSkus}
                  >
                    <span>Quick Add </span>+
                  </button>
                  {hasSizeSkus > 1 && (
                    <div class="grid-product__quick-add-panel">
                      {product.skus.map((sku) => {
                        let isOutOfStock = sku.availability === 'OutOfStock';

                        return (
                          <button
                            class="grid-product__quick-add-var"
                            data-id={sku.id}
                            disabled={isOutOfStock}
                          >
                            {sku.customFields.find(
                              (attr) => attr.key.toLowerCase() === 'size'
                            )?.value || 'N/A'}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              <a
                class="grid-product__link"
                href={product.url}
                aria-label={product.name}
                data-product={product}
              >

                  {isSoldOutItem && hasOutOfStockTag &&(
                    <div className="grid-product_notify-me">
                      <a
                        href="#"
                        className="SI_trigger"
                        data-product-data={JSON.stringify(productData)}
                      >
                        Out Of Stock - Notify me
                      </a>
                    </div>
                  )}

                  {isSoldOutItem && isComingSoon && (
                    <div className="grid-product_notify-me">
                      <a
                        href="#"
                        className="SI_trigger"
                        data-product-data={JSON.stringify(productData)}
                      >
                        Coming Soon - Notify me
                      </a>
                    </div>
                  )}

                <div class="gc_product_item_image-wrapper image-wrap">
                  <svg
                    class="gc_product_item_placeholder"
                    version="1.0"
                    xmlns="http://www.w3.org/2000/svg"
                    width="525.000000pt"
                    height="525.000000pt"
                    viewBox="0 0 525.000000 525.000000"
                    preserveAspectRatio="xMidYMid meet"
                  >
                    <g
                      transform="translate(0.000000,525.000000) scale(0.100000,-0.100000)"
                      fill="#000000"
                      stroke="none"
                    >
                      <path d="M220 3068 l0 -153 150 150 c83 82 150 151 150 152 0 2 -67 3 -150 3 l-150 0 0 -152z"></path>
                      <path d="M1255 3070 c82 -82 151 -150 152 -150 2 0 3 68 3 150 l0 150 -152 0 -153 0 150 -150z"></path>
                      <path d="M1786 3076 c-26 -79 -46 -149 -46 -155 0 -8 52 -11 170 -11 94 0 170 -2 170 -4 0 -2 -61 -198 -135 -436 -74 -238 -135 -437 -135 -442 0 -5 77 -7 172 -6 l172 3 137 440 136 440 90 3 90 3 6 -167 c4 -92 7 -235 7 -318 0 -83 3 -208 7 -279 l6 -127 156 2 155 3 206 313 205 312 6 -51 c4 -28 10 -169 14 -315 l8 -264 160 2 160 3 303 474 c167 261 304 471 304 467 0 -6 -229 -750 -286 -928 -5 -17 21 -18 449 -18 l454 0 53 153 c29 83 55 158 57 165 4 9 -55 12 -276 12 -155 0 -281 1 -281 3 0 1 58 196 129 432 l129 430 -322 3 c-297 2 -322 1 -334 -15 -7 -10 -97 -156 -200 -326 l-187 -307 -7 82 c-3 46 -6 171 -7 279 -1 108 -4 217 -7 243 l-7 46 -146 0 -146 0 -205 -322 -205 -322 -3 322 -2 322 -565 0 -564 0 -45 -144z"></path>
                      <path d="M547 2893 l-57 -58 107 -107 108 -108 -108 -108 -107 -107 57 -58 58 -57 107 107 108 108 105 -105 105 -105 57 57 57 57 -104 106 -104 105 104 105 104 106 -57 57 -57 57 -105 -105 -105 -105 -108 108 -107 107 -58 -57z"></path>
                      <path d="M220 2170 l0 -150 152 0 153 0 -150 150 c-82 83 -151 150 -152 150 -2 0 -3 -67 -3 -150z"></path>
                      <path d="M1255 2170 l-150 -150 153 0 152 0 0 150 c0 83 -1 150 -3 150 -1 0 -70 -67 -152 -150z"></path>
                    </g>
                  </svg>
                  <img
                    loading="lazy"
                    className="gc_product_item_image grid-product__image"
                    src={product.imageUrl ?? productImagePlaceholder}
                    srcSet={`${product.imageUrl.replace(
                      '.jpg',
                      '_300x.jpg'
                    )} 300w, ${product.imageUrl.replace(
                      '.jpg',
                      '_600x.jpg'
                    )} 600w, ${product.imageUrl.replace(
                      '.jpg',
                      '_900x.jpg'
                    )} 900w`}
                    sizes="(max-width: 600px) 300px, (max-width: 900px) 600px, 900px"
                    alt={product.name}
                    width="300"
                    height="300"
                  />
                </div>
              </a>
            </div>

            <div class="grid-product__meta-wrapper">
              <a
                href={product.url}
                class="grid-product__link"
                aria-label={product.name}
              >
                <div
                  style="display:none;"
                  class="discount-message__wrapper"
                ></div>
                <div class="grid-product__meta">
                  <div class="h5 text-bold grid-product__title grid-product__title--body">
                    {product.name}
                  </div>

                  <div class="gc_p_review">
                    <div
                      class="jdgm-widget jdgm-preview-badge"
                      data-id={product.productId}
                    >
                      
                      <Review
                        score={getCustomFieldText(
                          product.customFields,
                          'reviews-rating'
                        )}
                        count={getCustomFieldText(
                          product.customFields,
                          'judgeme-badge'
                        )}
                        />

                    </div>
                  </div>
                  {product.brand && (
                    <div class="grid-product__vendor">{product.brand}</div>
                  )}

                  {/* Price */}
                  <div class="grid-product__price">
                    {product.listPrice && product.listPrice > product.price && (
                      <>
                        <span class="text-bold text-red ns-pr-1">
                          <span class="money nsc_money">
                            {currencySymbol + product.price.toFixed(2)}
                          </span>
                        </span>
                        <span class="grid-product__price--original ns-text-striked">
                          <span class="money nsc_money">
                            <span class="money nsc_money">
                              {currencySymbol + product.listPrice.toFixed(2)}
                            </span>
                          </span>
                        </span>
                      </>
                    )}
                    {product.listPrice &&
                      product.listPrice === product.price && (
                        <span class="money nsc_money">
                          <span class="money nsc_money">
                            {currencySymbol + product.price.toFixed(2)}
                          </span>
                        </span>
                      )}
                    {product.listPrice && product.listPrice > product.price && (
                      <span class="grid-product__price--savings">
                        {`Save ${currencySymbol + saveDiscount.toFixed(2)}`}
                      </span>
                    )}
                  </div>
                  {/* Price end  */}
                </div>
              </a>
              {/* SWATCHES VARIANTS */}

              <div
                class="nosto-search-color-swatches-wrapper aa-wrapper aa-wrapper--colour-swatch"
                style=""
                data-section-type="product-color-swatch--full"
                data-request-query=""
                data-current-product=""
                data-product-name=""
                data-image-url-structure="//twl.com.au/cdn/shop/files/colour----productTitle---.png"
              >
                <div class="aa-container aa-container--colour-swatch nosto-search-color-swatches">
                  <span
                    class="nosto-swatch product-swatch-button product-swatch-button--colour-swatch aa-swatch--current aa-swatch--initial"
                    data-image=""
                    data-second-image=""
                    data-url=""
                    data-product=""
                    data-title=""
                    data-id=""
                    data-first-var-id=""
                    data-price=""
                    data-price-raw=""
                    data-compare-at-price=""
                    data-compare-at-price-raw=""
                    data-sizes=""
                    data-label-tags="[]"
                    data-discount-message=""
                    data-icon-label=""
                    title=""
                    style=""
                  ></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SerpElement>
  );
}
